import { useGame } from '../../contexts/GameContext';
import './Key.css';

function Key({ value, status, disabled }) {
  const { dispatch } = useGame();

  const handleClick = (e) => {
    e.preventDefault(); // Prevent any default behavior
    if (disabled) return;

    if (value === 'ENTER') {
      window.dispatchEvent(new CustomEvent('submitAttempt', { detail: 'SUBMIT_ATTEMPT' }));
    } else if (value === 'BACKSPACE') {
      dispatch({ type: 'REMOVE_LETTER' });
    } else {
      dispatch({ type: 'ADD_LETTER', letter: value });
    }
  };

  const isSpecial = value === 'ENTER' || value === 'BACKSPACE';
  const displayValue = value === 'BACKSPACE' ? '⌫' : value;

  const keyClass = [
    'key',
    isSpecial ? 'key-special' : '',
    status || '',
    disabled ? 'disabled' : ''
  ].filter(Boolean).join(' ');

  return (
    <button
      className={keyClass}
      onClick={handleClick}
      onTouchEnd={handleClick}
      disabled={disabled}
      aria-label={value}
    >
      {displayValue}
    </button>
  );
}

export default Key;